import { Button, InputNumber } from "antd";
import { useRef, useState } from "react";
import { selectOneSetting, selectPermissions } from "../../../util/store/selectors";
import { getStore, useSelector } from "../../../util/store/store";
import { IPropsChildren } from "../../../util/varibles/interface";
import { ACTION } from "../../../util/varibles/permission";
import { IUser } from "../../LoginPage/constants";
import styles from "./style.module.scss";

interface IProps extends IPropsChildren {
    propertyName?: string
    placeholder?: string
    suffix?: string

    forward?(value: number): number
    reverse?(value: number): number

    onSave?(value: Partial<IUser['setting']>): void
}

const SummarySetting: React.FC<IProps> = ({ children, propertyName = "", placeholder, suffix, forward, reverse, onSave }) => {
    const [open, setOpen] = useState(false);
    const inputRef = useRef<React.ElementRef<typeof InputNumber>>(null);
    const [value, setValue] = useState<number>(0);
    const [canUpdateBiologyOverview] = useSelector(selectPermissions([ACTION.BIOLOGY_OVERVIEW.UPDATE]));

    const onOpen = () => {
        setOpen(true);
        if (propertyName) {
            const v = selectOneSetting(propertyName)(getStore());
            setValue(forward ? forward(v) : v)
            setTimeout(() => {
                inputRef.current?.focus();
            }, 300);
        }
    }

    const onSend = () => {
        const body = { [propertyName]: reverse ? reverse(value) : value };
        onSave?.(body);
        setOpen(false);
    }

    return <>
        {canUpdateBiologyOverview
            ? <>
                <div className="link text-[15px]" onClick={onOpen}>
                    {children}
                </div>
                <div className={styles.summarySetting} data-open={open}>
                    <div data-lev="title">
                        <div className="bt-close" onClick={() => setOpen(false)} />
                    </div>
                    <div className="flex gap-2 w-full">
                        <InputNumber ref={inputRef} value={value} onChange={newValue => setValue(newValue || 0)} className="w-full rounded-[20px] overflow-hidden" placeholder={placeholder} suffix={suffix} />
                        <Button className="bt-ghost link" onClick={onSend}>
                            Save
                        </Button>
                    </div>
                </div>
            </>
            : <div className="text-[15px]" >
                {children}
            </div>}
    </>
}

export default SummarySetting;
